module.exports = __webpack_public_path__ + "img/document.e5636ae9.png";